import { compose } from 'recompose';

//Lodash
import _isNaN from 'lodash/isNaN';
import _isNumber from 'lodash/isNumber';
var isNotANumber = compose(_isNaN, _isNumber);
export var isUniDigitCount = function isUniDigitCount(badgeContent) {
  if (!badgeContent) {
    return false;
  }
  if (isNotANumber(badgeContent)) {
    return false;
  }
  return badgeContent < 10;
};